import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

const ProtectedRoute = ({ children }) => {
	const { accessToken, isInitialized } = useAuth();

	if (!isInitialized) return null;

	if (!accessToken) {
		return <Navigate to="/login" replace />;
	}

	return children;
};

export default ProtectedRoute;
